module.exports = __webpack_public_path__ + "img/branton-logo.e648453a.svg";